import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.00685 1.33301C10.4733 1.3331 12.5867 3.29978 12.667 5.67285C12.687 6.39952 12.4729 7.19331 12.1729 7.80664C12.1717 7.80785 12.167 7.81436 12.167 7.82031L8.58693 14.3271C8.46688 14.5536 8.23325 14.667 8.00001 14.667C7.76677 14.667 7.53314 14.5536 7.4131 14.3271L3.83302 7.82031C3.83302 7.81437 3.82831 7.80786 3.82716 7.80664C3.52716 7.19331 3.31302 6.39952 3.33302 5.67285C3.41328 3.29978 5.52674 1.3331 7.99318 1.33301H8.00685ZM8.00001 4.33301C7.07954 4.33301 6.33302 5.07953 6.33302 6C6.33302 6.92047 7.07954 7.66699 8.00001 7.66699C8.92049 7.66699 9.667 6.92047 9.667 6C9.667 5.07953 8.92049 4.33301 8.00001 4.33301Z",
		fill: "currentcolor"
	})
});
export default SvgLocation;
